import { useEffect, useState } from 'react';
import { SlackProjectSettings } from 'api/integrations/slack/slack.types';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';
import {
  useMutateProjectSlackNotificationSettings,
  useQueryProjectSlackNotificationSettings,
} from 'queries/slack-integration';

export const useProjectSlackNotification = (projectId: number) => {
  const translate = useTranslate();
  const [projectNotifySettings, setProjectNotifySettings] =
    useState<SlackProjectSettings | undefined>();
  const { status, refetch } = useQueryProjectSlackNotificationSettings(
    projectId,
    {
      onSuccess: (data) => {
        setProjectNotifySettings(data);
      },
      onError: () => {
        toastService({
          title: translate('project.settings.slack.load.failed.title'),
          message: translate('project.settings.slack.load.failed.message'),
        }).error();
      },
    },
  );

  const [isModalVisible, setShowModal] = useState<boolean>(false);

  const { mutate } = useMutateProjectSlackNotificationSettings(projectId, {
    onSuccess: () => {
      toastService({
        title: translate('project.settings.slack.update.success.title'),
        message: translate('project.settings.slack.update.success.message'),
      }).success();
    },
    onError: () => {
      toastService({
        title: translate('project.settings.slack.update.failed.title'),
        message: translate('project.settings.slack.update.failed.message'),
      }).error();
    },
  });

  const handleSettingsChange = (updatedSettings: SlackProjectSettings) => {
    setProjectNotifySettings((settings) => {
      return {
        ...settings,
        ...updatedSettings,
      };
    });
    mutate(updatedSettings);
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    projectNotifySettings,
    handleSettingsChange,
    isModalVisible,
    setShowModal,
    status,
  };
};
